import { Routes, Route, Navigate } from "react-router-dom";
import appInfo from "./app-info";
import routes from "./app-routes";
import { SideNavInnerToolbar as SideNavBarLayout } from "./layouts";
import { Footer } from "./components";
import Site from "./pages/site/site";
import About from "./pages/about/site";

export default function Content() {
  return (
    <Routes>
      <Route path="/" element={<Site />} />
      <Route path="/about" element={<About />} />

      {routes.map(({ path, element }) => (
        <Route key={path} path={path} element={element} />
      ))}

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
